import type { CommandType } from './PeripheralManufacturer'

export enum CommunicationType {
  Direct = 'DIRECT',
  DLL = 'DLL',
  Serial = 'SERIAL',
  Spooler = 'SPOOLER',
  USB = 'USB'
}

// Enums para configurações de balança
export enum ScaleBaudrate {
  Rate2400 = '2400',
  Rate4800 = '4800',
  Rate9600 = '9600',
  Rate12000 = '12000',
  Rate19600 = '19600'
}

export enum ScaleParity {
  None = 0,
  Odd = 1,
  Even = 2,
  Space = 3
}

export enum ScaleDataBits {
  Seven = 7,
  Eight = 8
}

// Enums para configurações de SAT
export enum SatLayoutVersion {
  Version1 = '0.07',
  Version2 = '0.08'
}

// Configurações comuns a todos os periféricos
interface CommonPeripheralSettings {
  address?: string
  port?: number
  model?: string
  communicationType?: CommunicationType
  commandType?: CommandType
}

// Configurações específicas para balança
export interface ScaleConfig {
  baudrate?: ScaleBaudrate
  parity?: ScaleParity
  serialPortConverter?: boolean
  databits?: ScaleDataBits
}

// Configurações específicas para SAT
export interface SatConfig {
  activationCode?: string
  layoutVersion?: SatLayoutVersion
  digitalSignature?: string
}

export interface PeripheralPrinterSettings extends CommonPeripheralSettings {
  // Configurações específicas para impressoras
}

export interface PeripheralScaleSettings extends CommonPeripheralSettings {
  scale?: ScaleConfig
}

export interface PeripheralSatSettings extends CommonPeripheralSettings {
  sat?: SatConfig
}
